import axiosInstance from '../api/axios';

export const signupService = {
  /**
   * Sign up a new user via the purchase-key-gated Cloud Function.
   * Firebase Auth client sign-up is admin-restricted; this creates the Auth
   * user with the Admin SDK, then the caller should signInWithEmailAndPassword.
   * @param {Object} userData - User registration data
   * @param {string} userData.firstname - User's first name
   * @param {string} userData.lastname - User's last name
   * @param {string} userData.email - User's email address
   * @param {string} userData.phone - User's phone number
   * @param {string} userData.password - Account password
   * @param {string} [userData.username] - Optional username
   * @param {string} [userData.coupon_code] - Optional coupon code
   * @param {string} [userData.purchase_key] - Purchase key unlock (required when public signup is closed)
   * @returns {Promise<Object>} Response from signup API
   */
  async signup(userData) {
    try {
      const response = await axiosInstance.post('/signup', userData);
      return response.data;
    } catch (error) {
      console.error('Signup error:', error);
      throw error;
    }
  },

  /**
   * Validate signup form data
   * @param {Object} userData - User registration data
   * @returns {Object} Validation result with errors array
   */
  validateSignupData(userData) {
    const errors = [];
    
    if (!userData.firstname || userData.firstname.trim().length < 2) {
      errors.push('First name must be at least 2 characters long');
    }
    
    if (!userData.lastname || userData.lastname.trim().length < 2) {
      errors.push('Last name must be at least 2 characters long');
    }
    
    if (!userData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email)) {
      errors.push('Please enter a valid email address');
    }
    
    if (!userData.phone || userData.phone.trim().length < 10) {
      errors.push('Please enter a valid phone number');
    }
    
    return {
      isValid: errors.length === 0,
      errors
    };
  }
};

export default signupService; 